window.catalogData = {
  "tyreBrands": [
    "Triangle",
    "Mickey Thompson",
    "Yokohama",
    "Maxxis",
    "Michelin",
    "Pirelli",
    "Cooper",
    "BF Goodrich",
    "Bridgestone",
    "Continental",
    "Kenda",
    "Kumho",
    "Marshal by Kumho",
    "Falken",
    "General",
    "GT Radial",
    "Mastercraft",
    "Nexen",
    "Toyo",
    "Radar",
    "Hankook"
  ],
  "wheelBrands": [
    "PDXX",
    "Dirty Life",
    "R Series",
    "Advanti Racing",
    "American Racing",
    "Asanti Wheels",
    "Enkei",
    "GT Form",
    "JSR Wheels",
    "Lenso",
    "Motegi",
    "Orbit",
    "Petrol",
    "Reproduction Wheels",
    "ROH",
    "Rotiform",
    "Speedy",
    "SpeedWorks",
    "Street Pro",
    "TSW",
    "US Mags",
    "Kensei",
    "CSA Wheels",
    "Konig",
    "Globe",
    "Raceline Wheels",
    "KMC Wheels",
    "Mayhem",
    "Level 8 Motorsports",
    "Icon Alloys",
    "Rubicon",
    "Mickey Thompson",
    "Moto Metal",
    "Pro Comp",
    "Dynamic Steel Wheels",
    "DWC Wheels",
    "Ion Wheels",
    "XD Wheels"
  ],
  "groups": [
    {
      "category": "Tyres",
      "brand": "Triangle",
      "sourceUrl": "https://triangle-tire.com/",
      "models": [
        "AdvanteX SUV TR259",
        "AdvanteX TC101",
        "AdvanteX TC101 EV",
        "AgileX A/T TR292",
        "AgileX M/T TR281",
        "ConneX Van TV701",
        "EffexSport TH202",
        "EffexSport TH201",
        "Protract TE301",
        "ReliaX Touring TE307",
        "Sportex TH201",
        "TR246",
        "TR257",
        "TR259",
        "TR292",
        "TR652",
        "TR665",
        "TR689A",
        "TR918",
        "TR928"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Mickey Thompson",
      "sourceUrl": "https://www.mickeythompsontires.com/light-truck-tires",
      "models": [
        "Baja Boss A/T",
        "Baja Boss M/T",
        "Baja Legend EXP",
        "Baja Legend MTZ",
        "Baja Legend MTZ Pro",
        "Baja Legend APZ",
        "Baja Pro XS",
        "Baja Pro X",
        "Baja Pro X Competition",
        "Baja Claw TTC",
        "Deegan 38 All-Terrain",
        "Deegan 38 Mud-Terrain",
        "Street Comp",
        "ET Street R",
        "ET Street S/S",
        "ET Street Radial Pro"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Yokohama",
      "sourceUrl": "https://www.yokohama.com.au/",
      "models": [
        "ADVAN Sport V107",
        "ADVAN Sport V105",
        "ADVAN Fleva V701",
        "ADVAN Neova AD09",
        "ADVAN A052",
        "BluEarth-GT AE51",
        "BluEarth AE01",
        "BluEarth ES32",
        "BluEarth RV-02",
        "BluEarth Van RY55",
        "Geolandar A/T G015",
        "Geolandar A/T4 G018",
        "Geolandar X-AT G016",
        "Geolandar M/T G003",
        "Geolandar CV G058",
        "Geolandar H/T G056",
        "Geolandar X-CV G057",
        "Advan dB V552",
        "Avid Ascend GT",
        "iceGUARD iG53"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Maxxis",
      "sourceUrl": "https://maxxistyres.com.au/shop/",
      "models": [
        "Razr AT811",
        "Razr MT772",
        "Razr HT780",
        "Bravo AT771",
        "Bravo AT771 HP",
        "Bravo HT770",
        "Bravo HP-M3",
        "Bravo UE-168",
        "Premitra HP5",
        "Victra Sport VS5",
        "Victra Sport EV",
        "Victra MA-Z4S",
        "Victra MA510",
        "Mecotra ME3",
        "MA-P5",
        "MA-751",
        "MA-589",
        "Mudzilla M8080",
        "Bighorn MT-764",
        "Creepy Crawler M8090"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Michelin",
      "sourceUrl": "https://www.michelin.com.au/auto/browse-tyres/all-tyres",
      "models": [
        "Pilot Sport 5",
        "Pilot Sport 4",
        "Pilot Sport 4 SUV",
        "Pilot Sport 4 S",
        "Pilot Sport Cup 2",
        "Pilot Sport A/S 4",
        "Primacy 5",
        "Primacy 4",
        "Primacy 4+",
        "Primacy SUV+",
        "Primacy Tour A/S",
        "Energy XM2+",
        "e.Primacy",
        "Latitude Sport 3",
        "Latitude Tour HP",
        "LTX Trail",
        "LTX Force",
        "Agilis 3",
        "Agilis CrossClimate",
        "CrossClimate 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Pirelli",
      "sourceUrl": "https://www.pirelli.com/tyres/en-au/car/catalogue",
      "models": [
        "P ZERO",
        "P ZERO (PZ4)",
        "P ZERO (PZ5)",
        "P ZERO E",
        "P ZERO CORSA SYSTEM",
        "P ZERO ROSSO",
        "POWERGY",
        "DRAGON SPORT",
        "CINTURATO P1",
        "CINTURATO P6",
        "CINTURATO P7",
        "CINTURATO P7 (P7C2)",
        "CINTURATO ROSSO",
        "CARRIER",
        "SCORPION ATR",
        "SCORPION STR",
        "SCORPION VERDE",
        "SCORPION VERDE ALL SEASON",
        "SCORPION ZERO",
        "SCORPION ZERO ALL SEASON",
        "SCORPION ZERO ASIMMETRICO",
        "SCORPION ALL TERRAIN PLUS",
        "SCORPION MTR",
        "SCORPION MS"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Cooper",
      "sourceUrl": "https://coopertires.com.au/our-range/",
      "models": [
        "ROAD+TRAIL AT",
        "STRONGHOLD AT",
        "LTZ PRO",
        "RUGGED TREK",
        "STT PRO",
        "AT3 LT",
        "AT3 4S",
        "AT3 XLT",
        "S/T MAXX",
        "ATT",
        "Pro Control",
        "CTT",
        "Discoverer HT3",
        "Discoverer SRX",
        "Evolution C5",
        "Zeon RS3-G1"
      ]
    },
    {
      "category": "Tyres",
      "brand": "BF Goodrich",
      "sourceUrl": "https://www.bfgoodrich.com.au/auto/browse-tyres/all-tyres",
      "models": [
        "All-Terrain T/A KO3",
        "All-Terrain T/A KO2",
        "Trail-Terrain T/A",
        "Mud-Terrain T/A KM3",
        "HD-Terrain T/A KT",
        "g-Force Phenom T/A",
        "g-Force Sport Comp-2",
        "Advantage Control",
        "Radial T/A",
        "Commercial T/A All-Season 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Bridgestone",
      "sourceUrl": "https://www.bridgestone.com.au/product",
      "models": [
        "Potenza Sport",
        "Potenza RE-71RS",
        "Potenza Adrenalin RE003",
        "Potenza S007A",
        "Turanza T005",
        "Turanza T005A",
        "Turanza T006",
        "Turanza Serenity Plus",
        "Ecopia EP300",
        "Ecopia H/L 001",
        "Dueler A/T 002",
        "Dueler A/T 697",
        "Dueler H/T 684",
        "Dueler H/P Sport",
        "Dueler M/T 674",
        "Alenza 001",
        "Alenza Sport A/S",
        "Weather Control A005",
        "Duravis R660",
        "Supercat A/T"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Continental",
      "sourceUrl": "https://www.continental-tires.com/au/en/products/",
      "models": [
        "SportContact 7",
        "SportContact 6",
        "PremiumContact 7",
        "PremiumContact 6",
        "EcoContact 6",
        "EcoContact 6 Q",
        "UltraContact",
        "ComfortContact CC7",
        "MaxContact MC7",
        "MaxContact MC6",
        "CrossContact LX25",
        "CrossContact LX Sport",
        "CrossContact ATR",
        "CrossContact H/T",
        "ContiSportContact 5",
        "ContiPremiumContact 5",
        "VanContact Eco",
        "VanContact Ultra",
        "AllSeasonContact",
        "WinterContact TS 870"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Kenda",
      "sourceUrl": "https://www.kendatires.com.au/tyres/offroad",
      "models": [
        "Klever R/T KR601",
        "Klever A/T2 KR628",
        "Klever M/T2 KR629",
        "Klever H/T2 KR600",
        "Komet Plus KR23",
        "Kenetica KR217",
        "Vezda UHP A/S KR400",
        "Vezda Touring A/S KR205",
        "Vezda Eco KR30",
        "Kargo Trail KR500",
        "Karrier KR33",
        "Komendo KR33A"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Kumho",
      "sourceUrl": "https://www.kumho.com.au/home/",
      "models": [
        "Ecsta PS71",
        "Ecsta PA51",
        "Ecsta PS91",
        "Ecsta HS52",
        "Ecsta HS51",
        "Ecsta KU39",
        "Solus TA21",
        "Solus TA31",
        "Solus KH17",
        "Sense KR26",
        "Crugen HP71",
        "Crugen HP91",
        "Crugen HT51",
        "Crugen KL33",
        "Road Venture AT52",
        "Road Venture AT51",
        "Road Venture MT71",
        "Road Venture MT51",
        "PorTran KC53",
        "WinterCraft WP72"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Marshal by Kumho",
      "sourceUrl": "https://www.marshaltyre.com.au/",
      "models": [
        "MH15",
        "MH12",
        "MU12",
        "HP91",
        "KL21",
        "HT51",
        "KL51",
        "AT51",
        "MT51",
        "KC53"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Falken",
      "sourceUrl": "https://www.falken.com.au/category/products/",
      "models": [
        "Wildpeak A/T3W",
        "Wildpeak A/T4W",
        "Wildpeak R/T01",
        "Wildpeak M/T01",
        "Wildpeak H/T02",
        "Wildpeak H/T HT01",
        "Azenis FK520",
        "Azenis FK510",
        "Azenis FK510 SUV",
        "Azenis RT615K+",
        "Azenis RT660",
        "Ziex ZE310 EcoRun",
        "Ziex ZE914 EcoRun",
        "Ziex CT60 A/S",
        "Sincera SN110",
        "Sincera SN832i",
        "Euroall Season AS220 Pro",
        "Linam VAN01",
        "Linam R51",
        "ZIEX S/TZ05"
      ]
    },
    {
      "category": "Tyres",
      "brand": "General",
      "sourceUrl": "https://generaltire.com/",
      "models": [
        "Grabber ATX",
        "Grabber A/TX",
        "Grabber AT3",
        "Grabber APT",
        "Grabber X3",
        "Grabber HTS60",
        "Grabber HTS",
        "Grabber UHP",
        "Grabber GT",
        "Grabber GT Plus",
        "Altimax One",
        "Altimax One S",
        "Altimax RT45",
        "Altimax 365AW",
        "G-MAX RS",
        "G-MAX AS-05"
      ]
    },
    {
      "category": "Tyres",
      "brand": "GT Radial",
      "sourceUrl": "https://gtradial.com.au/tyre-range/",
      "models": [
        "SportActive 2",
        "SportActive",
        "Champiro SX2",
        "Champiro FE2",
        "Champiro VP1",
        "Champiro ECO",
        "FE2 SUV",
        "Savero SUV",
        "Savero HT2",
        "Savero AT Plus",
        "Savero A/T Pro",
        "Savero M/T",
        "Adventuro AT3",
        "Adventuro M/T",
        "Maxmiler Pro",
        "Maxmiler WT2",
        "Maxmiler CX",
        "Komodo M/T Plus",
        "IcePro SUV 3",
        "WinterPro 2"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Mastercraft",
      "sourceUrl": "https://www.mastercrafttires.com/tires",
      "models": [
        "Courser All Weather",
        "Courser CXT",
        "Courser HXT",
        "Courser MXT",
        "Courser Quest",
        "Courser Quest Plus",
        "Courser Trail",
        "Courser Trail HD",
        "Courser Trail RT",
        "Avenger",
        "Avenger G/T",
        "Avenger M8",
        "Glacier MSR",
        "Glacier Trex",
        "SRT Touring",
        "Stratus AP",
        "Stratus AS",
        "Stratus HT"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Nexen",
      "sourceUrl": "https://www.nexentire.com/au/",
      "models": [
        "N'Fera Sport",
        "N'Fera SU1",
        "N'Fera SU4",
        "N'Fera AU7",
        "N'Blue HD Plus",
        "N'Blue 4Season",
        "N'Priz AH8",
        "N'Priz AH5",
        "Roadian ATX",
        "Roadian AT Pro RA8",
        "Roadian MTX",
        "Roadian HTX RH5",
        "Roadian GTX",
        "Roadian HP",
        "Roadian CT8",
        "Winguard Sport 2",
        "Winguard Ice Plus"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Toyo",
      "sourceUrl": "https://www.toyotires.com.au/",
      "models": [
        "Open Country A/T III",
        "Open Country A/T II",
        "Open Country R/T",
        "Open Country M/T",
        "Open Country H/T II",
        "Open Country U/T",
        "Open Country Q/T",
        "Open Country C/T",
        "Proxes Sport",
        "Proxes Sport 2",
        "Proxes Sport SUV",
        "Proxes C1S",
        "Proxes C100 Plus",
        "Proxes CF2",
        "Proxes R888R",
        "Proxes R1R",
        "NanoEnergy 3",
        "NanoEnergy Van",
        "Observe GSi-6",
        "Tranpath MPZ"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Radar",
      "sourceUrl": "https://radartyres.com.au/",
      "models": [
        "Renegade A/T Pro",
        "Renegade R/T+",
        "Renegade R7 M/T",
        "Renegade R5",
        "Renegade R/T",
        "Dimax R8+",
        "Dimax R8",
        "Dimax AS-8",
        "Dimax Classic",
        "Dimax 4 Season",
        "Rivera Pro 2",
        "Rivera Sport",
        "RPX800",
        "RPX10",
        "Argonite RV-4",
        "Argonite Alpine",
        "Angler RST22"
      ]
    },
    {
      "category": "Tyres",
      "brand": "Hankook",
      "sourceUrl": "https://www.hankooktire.com/au/en/home.html",
      "models": [
        "Ventus S1 evo3",
        "Ventus S1 evo3 SUV",
        "Ventus S1 evo Z",
        "Ventus Prime 4",
        "Ventus V12 evo2",
        "Ventus RS4",
        "Dynapro AT2",
        "Dynapro AT2 Xtreme",
        "Dynapro MT2",
        "Dynapro HP2",
        "Dynapro HT",
        "Dynapro HPX",
        "Kinergy Eco2",
        "Kinergy GT",
        "Kinergy 4S2",
        "Optimo K415",
        "Vantra LT",
        "Vantra Trailer",
        "iON evo",
        "iON evo SUV",
        "iON ST AS"
      ]
    },
    {
      "category": "Wheels",
      "brand": "PDXX",
      "sourceUrl": "https://pdxxoffroad.com/collections/all",
      "models": [
        "Control V8",
        "Fury",
        "Rock",
        "Enforcer",
        "Viking",
        "Kito Beadlock"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Dirty Life",
      "sourceUrl": "https://www.dirtylifewheels.com/all-wheels",
      "models": [
        "9316 Journey Street Series",
        "9315 Compound Street Series",
        "9317 DT-3",
        "9303 DT-1",
        "9310 Canyon",
        "9309 Canyon Pro",
        "9305 Theory",
        "9306 Mesa",
        "9307 Roadkill",
        "9301 Roadkill",
        "9302 Hammer",
        "9311 Enigma",
        "9312 Race",
        "9313 Mesa Race",
        "9314 DT-2",
        "9400 Roadkill Forged Beadlock"
      ],
      "images": {
        "9316 Journey Street Series": "https://images.squarespace-cdn.com/content/v1/591ddf011b10e33d96abaa5f/1677108190938-KMZDJ60L4QQP2YVLFJOT/DIRTYLIFE9316SB1.png?format=750w"
      }
    },
    {
      "category": "Wheels",
      "brand": "R Series",
      "sourceUrl": "https://rserieswheels.com/collections",
      "models": [
        "R10",
        "R20",
        "R30",
        "R40",
        "R50",
        "R60",
        "R70",
        "R80",
        "R90",
        "R100",
        "R150",
        "R200",
        "R300",
        "R400",
        "R500",
        "R600",
        "R700",
        "R800"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Advanti Racing",
      "sourceUrl": "https://www.advantiracingwheels.com/wheel-collection",
      "models": [
        "AXR Alonso 5",
        "AXR Predator 5",
        "AXR Predator 6",
        "AXR Stomper",
        "M8501",
        "Magnum",
        "MR82",
        "TT11 Titan",
        "Verona",
        "DST",
        "Vigoroso V1",
        "Vigoroso V2",
        "Hybris",
        "Racing Storm S1",
        "Racing Storm S2",
        "Racing Storm S3",
        "Advanti Storm",
        "Advanti Denaro"
      ]
    },
    {
      "category": "Wheels",
      "brand": "American Racing",
      "sourceUrl": "https://www.americanracing.com/wheels/all-wheels",
      "models": [
        "500 Mono Cast",
        "AR23",
        "AR904",
        "AR907",
        "Baja",
        "Baja Dually",
        "Barrage",
        "Bishop",
        "Boss TT",
        "Burnout",
        "Classic Torq Thrust II",
        "Classic Torq Thrust II Custom",
        "Crossfire",
        "Draft",
        "G-Force",
        "Gasser",
        "Groove",
        "GT Street",
        "Hopster",
        "Mach Five",
        "Mainline",
        "Marauder",
        "Nova",
        "Outlaw I",
        "Outlaw II",
        "Satin Black AR172",
        "Torq Thrust D",
        "VN105 Torq Thrust D",
        "VN309 Torq Thrust Original",
        "VN427 Shelby Cobra"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Asanti Wheels",
      "sourceUrl": "https://www.asantiwheels.com/products/wheels",
      "models": [
        "Corona",
        "Viceroy",
        "Ablaze",
        "Axiom",
        "Black Label ABL-1",
        "Black Label ABL-2",
        "Black Label ABL-5",
        "Black Label ABL-12",
        "Black Label ABL-14",
        "Black Label ABL-15",
        "Black Label ABL-18",
        "Black Label ABL-22",
        "Black Label ABL-23",
        "AF111",
        "AF112",
        "AF113",
        "AF114",
        "AF115",
        "AF116",
        "AF117",
        "AF118",
        "AF119",
        "AF120",
        "AF121",
        "AF122",
        "AF123",
        "AF124",
        "AF125",
        "AF126",
        "AF127"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Enkei",
      "sourceUrl": "https://enkei.com/wheels/",
      "models": [
        "RPF1",
        "RPF1RS",
        "NT03+M",
        "NT03RR",
        "GTC01",
        "GTC02",
        "RS05RR",
        "PF01",
        "PF01EVO",
        "PF05",
        "PF07",
        "PF09",
        "TS-5",
        "TS-7",
        "TS-V",
        "TS10",
        "TS9",
        "T6R",
        "T6S",
        "TFR",
        "TM7",
        "TMS",
        "Raijin",
        "Kojin",
        "Fujin",
        "Tenjin",
        "Compe",
        "Apache II",
        "Enkei92",
        "RPT1",
        "Overlander",
        "M5",
        "M6",
        "FD-05",
        "TSP-5",
        "GW8",
        "Lusso",
        "RSM9",
        "RP03"
      ]
    },
    {
      "category": "Wheels",
      "brand": "GT Form",
      "sourceUrl": "https://www.gtformwheels.com/",
      "models": [
        "Anvil",
        "Argon",
        "GFS1",
        "Shadow",
        "Legacy",
        "Marquee",
        "Venom",
        "Interflow",
        "Torque"
      ]
    },
    {
      "category": "Wheels",
      "brand": "JSR Wheels",
      "sourceUrl": "https://jsrwheels.com/wheels/",
      "models": [
        "ST06",
        "ST10",
        "ST15",
        "ST19"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Lenso",
      "sourceUrl": "https://lensowheels.com.au/collections/all-wheels",
      "models": [
        "KAOS",
        "AMADA",
        "D-1SF",
        "V1N",
        "D-1R",
        "DINERO",
        "CARTEL",
        "D1R-EVO",
        "BSX",
        "90-Z",
        "D-1FC",
        "SPEC-E",
        "D-1SE",
        "Marvel",
        "Argo",
        "M-79",
        "Hurricane",
        "Gravel"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Motegi",
      "sourceUrl": "https://www.motegiwheels.com/products/wheels/all-wheels",
      "models": [
        "MR154 Battle",
        "MR159 Battle V",
        "MR160 Battle VI",
        "MR147 CM7",
        "MR157 CM8",
        "MR127 CS10",
        "MR143 CS6",
        "MR142 CS8",
        "MR116 FS5",
        "MR161 Kojin",
        "MR144 M9",
        "MR131 Traklite",
        "MR118 MS7",
        "MR139 RF11",
        "MR145 Traklite 3.0",
        "MR146 SS6",
        "MR151 CS5",
        "MR152 SS5",
        "MR153 CM10",
        "MR156 Hypergram",
        "MF412 SS5",
        "MF413 SS6",
        "MF414 Tsubaki",
        "MF415 Battle",
        "MF416 Battle V",
        "MF417 Millennium",
        "MF418 EXO6",
        "MF419 EXO4",
        "MF420 EXO",
        "MF421 SS3"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Orbit",
      "sourceUrl": "https://www.jaxtyres.com.au/wheels/orbit",
      "models": [
        "Casa",
        "Fitti",
        "Venator",
        "Lotus",
        "Monza"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Petrol",
      "sourceUrl": "https://www.petrolwheels.com/",
      "models": [
        "P0A",
        "P1A",
        "P2A",
        "P3C",
        "P4B",
        "P5C",
        "P6A",
        "P7C",
        "P8A",
        "P9B",
        "P10A",
        "P11B",
        "P12C",
        "P13A",
        "P14B",
        "P15C",
        "P16A",
        "P17B",
        "P18C",
        "P19A"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Reproduction Wheels",
      "sourceUrl": "https://www.reproductionwheels.com.au/",
      "models": [
        "Commodore VE SSV",
        "Commodore VF SSV",
        "Commodore HSV GTS",
        "Commodore HSV Senator",
        "Commodore Walkinshaw",
        "Ford Falcon FG GT",
        "Ford Falcon XR6 Turbo",
        "Ford Mustang GT",
        "Toyota LandCruiser GXL",
        "Toyota LandCruiser Sahara",
        "Nissan Patrol Warrior",
        "Ranger Wildtrak",
        "Raptor Style",
        "BMW M Performance",
        "Mercedes AMG Style"
      ]
    },
    {
      "category": "Wheels",
      "brand": "ROH",
      "sourceUrl": "https://roh.com.au/",
      "models": [
        "Assault",
        "Avenger",
        "Blak Trak",
        "Cairo",
        "Dakar",
        "Hammer",
        "Havoc",
        "Hostage",
        "Impulse",
        "Invader",
        "Maverick",
        "Octagon",
        "Raid",
        "Razor",
        "Sniper",
        "Storm",
        "Trophy",
        "Vapour",
        "Vector",
        "Voltage",
        "Zeta"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Rotiform",
      "sourceUrl": "https://www.rotiform.com/products/wheels",
      "models": [
        "ZMO-M",
        "LSE",
        "OZR-T",
        "BPU",
        "RPS",
        "LTN-J",
        "356",
        "917",
        "ARO",
        "AVS",
        "BKK",
        "BLQ",
        "BLQ-C",
        "BLQ-T",
        "BM1",
        "BRU",
        "BTC",
        "BTH",
        "BTL",
        "BUC",
        "CCV",
        "CIN",
        "CVT",
        "DIA",
        "DTM",
        "FLG",
        "KPS",
        "LAS-R",
        "LHR-M",
        "MUC",
        "NUE",
        "OZT",
        "RSE",
        "SGN",
        "SIX",
        "STL",
        "TUF-R"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Speedy",
      "sourceUrl": "https://speedywheels.com.au/wheels",
      "models": [
        "Alpha",
        "Assault",
        "Axe",
        "Beast",
        "Bedrock",
        "Bronco",
        "Chaos",
        "Cobra",
        "Combat",
        "Dart",
        "Drifter",
        "Grande 2",
        "Havoc",
        "Hotwire",
        "Interceptor",
        "Matterhorn",
        "Outlaw",
        "Rhino",
        "Sandstorm",
        "Savage",
        "Territory",
        "Wasteland",
        "Allure",
        "Badger",
        "Carbine",
        "Cheetah",
        "Cobalt RS",
        "Deceit",
        "Hammer",
        "Hotshot",
        "Impala",
        "Liberator",
        "Monaco",
        "Panther",
        "Podium",
        "Redback",
        "Rewind",
        "Sonic",
        "Stinger",
        "Track",
        "Desert Rat",
        "Swamp Rat"
      ]
    },
    {
      "category": "Wheels",
      "brand": "SpeedWorks",
      "sourceUrl": "https://www.speedworks.com.au/collections/alloy-wheels",
      "models": [
        "SW01",
        "SW02",
        "SW03",
        "SW04",
        "SW05",
        "SW06",
        "SW07",
        "SW08",
        "SW09",
        "SW10",
        "SW11",
        "SW12",
        "SW13",
        "SW14",
        "SW15",
        "SW16",
        "SW17",
        "SW18",
        "SW19",
        "SW20",
        "SW21",
        "SW22",
        "SW23",
        "Eclipse",
        "WS MAX 20",
        "SWF01",
        "SWF02",
        "SWF03",
        "SWF04",
        "SWF05",
        "SWF06",
        "SWF07",
        "SWF08",
        "SWF09",
        "SWF10",
        "SWF11",
        "SWF12",
        "SWF13",
        "SWF14",
        "SWF15",
        "SWF16",
        "SWF18",
        "SWF20",
        "Forge-Fit 001 - Mercedes S-Class W222",
        "Forge-Fit 002 - Mercedes S-Class W222",
        "Forge-Fit 003 - Audi R8 Type 4S",
        "Forge-Fit 004 - BMW X4 M F98/G02"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Street Pro",
      "sourceUrl": "https://www.streetprowheels.com.au/wheels",
      "models": [
        "002 Series",
        "005 Series",
        "007 Series",
        "009 Series"
      ]
    },
    {
      "category": "Wheels",
      "brand": "TSW",
      "sourceUrl": "https://www.tsw.com/wheels/all-wheels",
      "models": [
        "Bathurst",
        "Canard",
        "Clypse",
        "Daytona",
        "Esprit",
        "Goodwood",
        "Imatra",
        "Imola",
        "Kemora",
        "Lasarthe",
        "Launch",
        "Max",
        "Mechanica",
        "Neptune",
        "Pescara",
        "Sebring",
        "Sector",
        "Silverstone",
        "Slipstream",
        "Snetterton",
        "Sprint"
      ]
    },
    {
      "category": "Wheels",
      "brand": "US Mags",
      "sourceUrl": "https://www.us-mags.com/",
      "models": [
        "1 Piece Rambler",
        "1 Piece Indy",
        "1 Piece Standard",
        "1 Piece Bullet",
        "1 Piece Bandit",
        "1 Piece Desperado",
        "1 Piece Rambler U111",
        "1 Piece Indy U101",
        "1 Piece Standard U102",
        "1 Piece Bullet U104",
        "1 Piece Bandit U109",
        "Cast Rambler",
        "Cast Indy",
        "Cast Bullet",
        "Cast Bandit",
        "Cast Desperado",
        "Forged Detroit",
        "Forged Bonneville",
        "Forged Monaco"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Kensei",
      "sourceUrl": "https://kanseiwheels.com/",
      "models": [
        "KNP",
        "Tandem",
        "Roku",
        "Astro",
        "Corsa",
        "Neo",
        "Kegari",
        "Kaze",
        "Shogun",
        "Tandem Aero",
        "Roku Beadlock",
        "KNP Classic",
        "Astro Directional",
        "Corsa Lite"
      ]
    },
    {
      "category": "Wheels",
      "brand": "CSA Wheels",
      "sourceUrl": "https://csawheels.com.au/catalogue/",
      "models": [
        "Bronx",
        "Brooklyn",
        "Cheetah",
        "Commando",
        "Corsair",
        "Demon",
        "Drift",
        "Hawk",
        "Hurricane",
        "Jackal",
        "Krawler",
        "Mako",
        "Maverick",
        "Militant",
        "Monster",
        "Mullins Trailer",
        "Outlaw",
        "Predator",
        "Raptor",
        "Rebel",
        "Renegade",
        "Ridgeline",
        "Savanna",
        "Scorpion",
        "Stingray",
        "Typhoon",
        "Viper",
        "Wolf"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Konig",
      "sourceUrl": "https://konigwheels.com/collections/wheels",
      "models": [
        "Hypergram",
        "Dekagram",
        "Ampliform",
        "Hexaform",
        "Rennform",
        "Dial-In",
        "Diverge",
        "Lockout",
        "Tandem",
        "Myth",
        "Countergram",
        "Freeform",
        "Oversteer",
        "Runlite",
        "Ultraform",
        "Control",
        "Helium",
        "Illusion",
        "Incident",
        "Interflow",
        "Mainline",
        "Reasons",
        "Rewind",
        "Torch",
        "Wideopen"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Globe",
      "sourceUrl": "https://www.globewheels.com.au/",
      "models": [
        "Bathurst",
        "Sprint",
        "Rally",
        "Rallymaster",
        "Dragway",
        "Daytona",
        "Eliminator",
        "Interceptor",
        "Classic",
        "Sportsman",
        "GTS",
        "Monza",
        "Challenger",
        "Cruiser"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Raceline Wheels",
      "sourceUrl": "https://racelinewheels.com/pages/catalog",
      "models": [
        "Alpha Beadlock",
        "Alpha",
        "Aviator",
        "Clutch",
        "Defender",
        "Gauge",
        "Hostage",
        "Injector",
        "Mamba",
        "Monster",
        "Mamba Beadlock",
        "Podium",
        "Raptor",
        "Shift",
        "Scout",
        "Assault",
        "Avenger",
        "Boost",
        "Compass",
        "Combat",
        "Mamba HD",
        "Outlander",
        "Renegade",
        "Rockcrusher",
        "Ryno",
        "Siege",
        "Split",
        "Twist"
      ]
    },
    {
      "category": "Wheels",
      "brand": "KMC Wheels",
      "sourceUrl": "https://www.kmcwheels.com/wheels",
      "models": [
        "E25 Beadlock",
        "Crux",
        "Attack",
        "Impact FFT",
        "Archer",
        "Impact Beadlock",
        "Torx",
        "Aztec",
        "Bully",
        "Bully OL",
        "Canyon",
        "Carnage",
        "Chase",
        "Dirty Harry",
        "Enduro",
        "Grenade Crawl Beadlock",
        "Grenade Desert Beadlock",
        "GRS",
        "Hatchet",
        "Impact",
        "Impact Forged Beadlock",
        "Impact Forged Monoblock",
        "Impact OL",
        "IMS",
        "KM535 Grenade OR",
        "KM540 Recon",
        "KM544 Mesa",
        "KM545 Trek",
        "KM546 Timer",
        "KM549 GRS",
        "KM550 Riot",
        "KM552 IMS"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Mayhem",
      "sourceUrl": "https://www.mayhemwheels.com/",
      "models": [
        "Apollo",
        "Arsenal",
        "Assault",
        "Beast",
        "Bigrig",
        "Challenger",
        "Chaos",
        "Cogent",
        "Cogent Dually",
        "Combat",
        "Compass",
        "Convoy",
        "Cortex",
        "Crossfire",
        "Decoy",
        "Delta",
        "Essex",
        "Fierce",
        "Flat Iron",
        "Flywheel",
        "Granite",
        "Hammer",
        "Hatchet",
        "Havoc",
        "Hermosa",
        "Horizon",
        "Intrepid",
        "Missile",
        "Monstir",
        "Ordinance",
        "Patriot",
        "Prodigy",
        "Rampage",
        "Ridgeline",
        "Riot",
        "Scout",
        "Tank",
        "Tripwire",
        "Utopia",
        "Vanquish",
        "Vector",
        "Voyager",
        "Warrior"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Level 8 Motorsports",
      "sourceUrl": "https://www.level8wheels.com/",
      "models": [
        "Bully Pro",
        "Enforcer",
        "MK6",
        "Punch",
        "Strike 5",
        "Strike 6",
        "Tracker",
        "Tracker Pro",
        "Slingshot",
        "ZX",
        "Guardian",
        "Interceptor",
        "Razor",
        "Recon",
        "Slam",
        "Summit",
        "Tactic",
        "Vandal"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Icon Alloys",
      "sourceUrl": "https://iconvehicledynamics.com/collections/wheels",
      "models": [
        "Alpha",
        "Anza",
        "Bandit",
        "Cajon",
        "Compass",
        "Compression",
        "Compression HD",
        "Hammer Pro",
        "Hulse",
        "Journey",
        "Nuevo",
        "Raider",
        "Rancho",
        "Rebound",
        "Rebound HD",
        "Rebound Pro",
        "Rebound SLX",
        "Recoil",
        "Recon Pro",
        "Recon SLX",
        "Ricochet",
        "Shield",
        "Six Speed",
        "Thrust",
        "Vector 5",
        "Vector 6",
        "Victory"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Rubicon",
      "sourceUrl": "",
      "models": [
        "JL Rubicon OEM Style",
        "JK Rubicon OEM Style",
        "Gladiator Rubicon OEM Style",
        "Rubicon Xtreme Recon OEM Style",
        "Rubicon 392 OEM Style",
        "Rubicon Hard Rock OEM Style",
        "Rubicon Recon OEM Style",
        "Rubicon 10th Anniversary OEM Style"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Mickey Thompson",
      "sourceUrl": "https://www.mickeythompsontires.com/wheels",
      "models": [
        "Classic III",
        "Classic Baja Lock",
        "Classic Baja Boss",
        "Classic Sidebiter II",
        "Classic Lock",
        "Classic III Black",
        "Classic III Polished",
        "Deegan 38 Pro 2",
        "Metal Series MM-245",
        "Metal Series MM-366",
        "Metal Series MM-489",
        "Sidebiter II",
        "Baja Pro",
        "ET Drag"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Moto Metal",
      "sourceUrl": "https://www.motometal.com/wheels",
      "models": [
        "Tekton",
        "Breakout",
        "Combat",
        "Folsom",
        "Kraken",
        "Legacy",
        "MO806",
        "MO807",
        "MO970",
        "MO995",
        "Razor",
        "Siege",
        "Sniper",
        "Spider",
        "Stinger",
        "Turbine",
        "Warlock"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Pro Comp",
      "sourceUrl": "https://www.procompusa.com/category/wheels/",
      "models": [
        "Stryker",
        "Snare",
        "Grid",
        "Wraith",
        "Roughneck",
        "Heritage",
        "Beacon",
        "Basecamp",
        "Pulse",
        "Patriot",
        "Bandido",
        "Vintage",
        "Torq",
        "Trilogy",
        "Axis",
        "Cognos",
        "Rockwell",
        "La Paz",
        "Phaser",
        "Vertigo",
        "Predator",
        "Kore",
        "Gunner",
        "Vapor Pro 2"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Dynamic Steel Wheels",
      "sourceUrl": "https://dynamicwheelco.com.au/wheel/dynamic-steel-wheels/",
      "models": [
        "Sunraysia Imitation Beadlock",
        "Sunraysia Genuine Beadlock",
        "Sunraysia",
        "Soft 8 Imitation Beadlock",
        "Soft 8",
        "Smoothie",
        "Slotted",
        "Round Imitation Beadlock",
        "Round HL Mine Spec",
        "Round Genuine Beadlock",
        "Round",
        "OEM Plus",
        "Interceptor",
        "Drift D",
        "D Shape Imitation Beadlock",
        "D Shape Genuine Beadlock",
        "D Shape",
        "Drift Soft 8"
      ]
    },
    {
      "category": "Wheels",
      "brand": "DWC Wheels",
      "sourceUrl": "https://dynamicwheelco.com.au/wheel/dwc-wheels/",
      "models": [
        "Sentinel",
        "Convict",
        "Legend",
        "DWC79",
        "Brutal",
        "Lockup",
        "DWC92",
        "666 Devil"
      ]
    },
    {
      "category": "Wheels",
      "brand": "Ion Wheels",
      "sourceUrl": "https://www.ionalloy.com/",
      "models": [
        "101",
        "102",
        "103",
        "133",
        "135",
        "141",
        "143",
        "144",
        "146",
        "147",
        "149",
        "151",
        "167",
        "171",
        "174",
        "179",
        "181",
        "183",
        "184",
        "186",
        "187",
        "189",
        "190",
        "193",
        "194"
      ]
    },
    {
      "category": "Wheels",
      "brand": "XD Wheels",
      "sourceUrl": "https://www.xdwheels.com/wheels",
      "models": [
        "Colossus",
        "Bomber",
        "Buck 25",
        "FMJ",
        "Gauntlet",
        "Grenade 2",
        "Grenade Dually",
        "Grenade II",
        "Hoss II",
        "Monster",
        "Monster 2",
        "Monster 3",
        "Omega",
        "Onslaught",
        "Outbreak",
        "Outlander",
        "Panzer",
        "Pike Dually",
        "R.O.F.",
        "Raid",
        "Reactor",
        "Rockstar",
        "Rover",
        "RS2",
        "Spy",
        "Surge",
        "Tank",
        "Thump",
        "XD820 Grenade",
        "XD827 Rockstar III"
      ]
    }
  ]
};
